import { createAction } from "@reduxjs/toolkit";

// Action types
export const SET_SELECTED_CATEGORY = "category/setSelectedCategory";
export const CLEAR_SELECTED_CATEGORY = "category/clearSelectedCategory";

// Action creators
export const setSelectedCategory = createAction<string | null>(
  SET_SELECTED_CATEGORY
);

export const clearSelectedCategory = createAction(CLEAR_SELECTED_CATEGORY);
